import { Injector, Type, InjectionToken, InjectFlags } from '@angular/core';

export class MaxDialogInjector implements Injector {

    constructor(private parentInjector: Injector, private additionalTokens: WeakMap<any, any>) { }

    get<T>(token: Type<T> | InjectionToken<T>, notFoundValue?: T, flags?: InjectFlags): T;
    get(token: any, notFoundValue?: any, flags?: any) {
        const injectors = this.additionalTokens.get(token);

        if (injectors) { return injectors; }

        return this.parentInjector.get<any>(token, notFoundValue);
    }

}
